import { Link } from "../Link/Link";
import { Button } from "@lya-protect/lya-protect-form-library/dist/UI";
import { useLocation, useMatch } from "react-router-dom";
import { ReactElement } from "react";
import classNames from "classnames";
import Logo from "../../assets/logo.png";
import styles from "./SideBar.module.scss";

type SidebarLinkProps = {
  to: string;
  children: string | ReactElement;
  precise?: boolean;
};
export function SidebarLink({
  to,
  children,
  precise = false,
}: SidebarLinkProps) {
  const { pathname, search } = useLocation();
  const [path, query] = to.split("?");
  const match = useMatch(`${path}${precise ? "" : "/*"}`);
  const isActive = query
    ? pathname + search === `${path}?${query}`
    : !!match && (pathname !== path || !search);
  return (
    <Link
      to={to}
      className={classNames(styles.link, { [styles.active]: isActive })}
    >
      {children}
    </Link>
  );
}

type SidebarScrollLinkProps = {
  children: string | ReactElement;
  onClick: () => void;
  isActive?: boolean;
};
export function SidebarScrollLink({
  children,
  onClick,
  isActive = false,
}: SidebarScrollLinkProps) {
  return (
    <Button
      onClick={onClick}
      className={classNames(styles.buttonScroll, { [styles.active]: isActive })}
      type="button"
      variant="text"
    >
      {children}
    </Button>
  );
}
export function SidebarSubtitle({ children }: { children: string }) {
  return <p className={styles.subtitle}>{children}</p>;
}
export function SidebarDelimiter() {
  return <div className={styles.delimiter} />;
}
type SidebarProps = {
  hasRoleEndya?: boolean;
  prenom?: string,
  nom?: string
  children: (false | JSX.Element | JSX.Element[])[];
};
export function Sidebar({ hasRoleEndya, prenom, nom, children }: SidebarProps) {
  return (
    <div className={styles.sidebar}>
      <Link to="/">
        <img className={styles.logo} src={Logo} alt="endya logo" />
      </Link>
      {hasRoleEndya && (
        <p className={styles.connectedAs}>
          Connecté en tant que {prenom} {nom}
        </p>
      )}
      {children}
    </div>
  );
}
